import _objectSpread from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useOverlayTriggerState as $9Xvoh$useOverlayTriggerState } from "@react-stately/overlays";
import { useState as $9Xvoh$useState } from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $a28c903ee9ad8dc5$exports = {};
$parcel$export($a28c903ee9ad8dc5$exports, "useMenuTriggerState", function () {
  return $a28c903ee9ad8dc5$export$79fefeb1c2091ac3;
});

function $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(props) {
  var overlayTriggerState = $9Xvoh$useOverlayTriggerState(props);

  var _$9Xvoh$useState = $9Xvoh$useState(null),
      _$9Xvoh$useState2 = _slicedToArray(_$9Xvoh$useState, 2),
      focusStrategy1 = _$9Xvoh$useState2[0],
      setFocusStrategy = _$9Xvoh$useState2[1];

  return _objectSpread(_objectSpread({
    focusStrategy: focusStrategy1
  }, overlayTriggerState), {}, {
    open: function open() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      setFocusStrategy(focusStrategy);
      overlayTriggerState.open();
    },
    toggle: function toggle() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      setFocusStrategy(focusStrategy);
      overlayTriggerState.toggle();
    }
  });
}

export { $a28c903ee9ad8dc5$export$79fefeb1c2091ac3 as useMenuTriggerState };